export const adaptAllTipoProfesionalEspecialidad = (tipoProfesionalEspecialidadData) => {
    return {
        value: tipoProfesionalEspecialidadData?.idTipoProfesionalEspecialidad,
        id: tipoProfesionalEspecialidadData?.idTipoProfesionalEspecialidad,
        displayName: tipoProfesionalEspecialidadData?.nombre,
        label: tipoProfesionalEspecialidadData?.nombre
    }
}

export const adaptAllTipoProfesionalEspecialidadArray = (
    tipoProfesionalesEspecialidad
) => {
    return structuredClone(tipoProfesionalesEspecialidad?.tipoProfesionalEspecialidad)
        ?.map(tipoProfesionalEspecialidad => adaptAllTipoProfesionalEspecialidad(tipoProfesionalEspecialidad));
}